import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, MapPin } from "lucide-react";
import { MaskLines, FadeIn } from "@/components/site/Reveal";
import { TypeWord } from "./TypeWord";

const DEFAULT_H = "Your Business. Your Goals. Let\u2019s Grow Together.";

const Portrait = () => (
  <motion.div initial={{ clipPath: "inset(100% 0 0 0 round 240px 240px 28px 28px)" }} animate={{ clipPath: "inset(0% 0 0 0 round 240px 240px 28px 28px)" }}
    transition={{ duration: 1.3, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
    className="relative mx-auto hidden aspect-[4/5] w-full max-w-[420px] overflow-hidden bg-[#3B0F7A] lg:block">
    <img src="/img/freya-86.jpg" alt="Freya Jones, founder of Digital AdDoctor" className="h-full w-full object-cover object-top" fetchPriority="high" />
  </motion.div>
);

export const HomeHero = ({ s }) => {
  const h = s.hero_headline || DEFAULT_H;
  const lines = h === DEFAULT_H
    ? ["Your Business.", "Your Goals.", <>Let&rsquo;s Grow <TypeWord word="Together." /></>]
    : [h];
  const support = String(s.hero_support || "").split(/\n{2,}/).filter(Boolean);
  return (
    <section className="relative bg-gradient-to-b from-[#2E1065] to-[#3B0F7A] pb-16 pt-28 text-white sm:pb-20 sm:pt-36" data-testid="home-hero">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-[1.35fr_1fr]">
        <div>
          <FadeIn>
            <h1 className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-[#D8CCFF] sm:text-sm" data-testid="home-h1">
              <MapPin className="h-4 w-4 shrink-0 text-[#FF8A65]" aria-hidden />Digital Marketing Consultant in Tunbridge Wells
            </h1>
          </FadeIn>
          <FadeIn className="mt-5 flex items-center gap-3">
            <p className="text-sm font-bold text-[#D8CCFF] sm:text-base" data-testid="hero-tagline">{s.hero_tagline || "A Digital Marketing Agency With a Human Touch."}</p>
          </FadeIn>
          <MaskLines lines={lines} as="h2" testid="hero-headline" className="mt-5 text-[2.6rem] font-extrabold leading-[1.02] sm:text-5xl lg:text-6xl" />
          <FadeIn delay={0.5}>
            <p className="mt-7 max-w-xl text-lg font-bold leading-snug text-white md:text-xl" data-testid="hero-subheading">{s.hero_subheading || "Great digital marketing starts with understanding people."}</p>
            {support.map((p, i) => <p key={i} className="mt-4 max-w-xl text-base leading-relaxed text-violet-100">{p}</p>)}
            {s.hero_closing && <p className="serif-accent mt-5 text-xl text-[#D8CCFF] sm:text-2xl" data-testid="hero-closing">{s.hero_closing}</p>}
          </FadeIn>
          <FadeIn delay={0.7} className="mt-8 flex flex-wrap gap-3">
            <Link to="/contact?type=audit" className="btn-accent !px-7 !py-4 text-base" data-testid="hero-audit-cta">Get Your Free Digital Audit <ArrowUpRight className="h-4 w-4" /></Link>
            <a href="#services" className="btn-ghost-dark !px-7 !py-4 text-base" data-testid="hero-services-cta">Explore My Services</a>
          </FadeIn>
        </div>
        <Portrait />
      </div>
    </section>
  );
};
